import { memo } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import NoteDropdown from './noteDropdown';

export const EYE_EXAM_ITEMS = [
  { key: 'va', label: 'VA (Visual Acuity)', placeholder: 'Search/Add VA Note' },
  {
    key: 'll',
    label: 'L/L – Lids & Lashes',
    placeholder: 'Search/Add L/L Note',
  },
  {
    key: 'conj',
    label: 'CONJ – Conjunctiva',
    placeholder: 'Search/Add CONJ Note',
  },
  {
    key: 'sclera',
    label: 'SCLERA – Sclera',
    placeholder: 'Search/Add SCLERA Note',
  },
  { key: 'cor', label: 'COR – Cornea', placeholder: 'Search/Add COR Note' },
  {
    key: 'ac',
    label: 'A/C – Anterior Chamber',
    placeholder: 'Search/Add A/C Note',
  },
  { key: 'iris', label: 'IRIS', placeholder: 'Search/Add IRIS Note' },
  { key: 'pupil', label: 'PUPIL', placeholder: 'Search/Add PUPIL Note' },
  { key: 'lens', label: 'LENS', placeholder: 'Search/Add LENS Note' },
  { key: 'vit', label: 'VIT – Vitreous', placeholder: 'Search/Add VIT Note' },
  { key: 'fundus', label: 'FUNDUS', placeholder: 'Search/Add FUNDUS Note' },
  { key: 'iop', label: 'IOP', placeholder: 'Search/Add IOP Note' },
  { key: 'eom', label: 'EOM', placeholder: 'Search/Add EOM Note' },
  { key: 'others', label: 'Others', placeholder: 'Search/Add Others Note' },
];

export const defaultEyeExamination = () =>
  EYE_EXAM_ITEMS.reduce((acc, { key }) => {
    acc[key] = { right: '', left: '' };
    return acc;
  }, {});


const EyeExamination = ({ selectedOnExamination, handleOnExaminationData }) => {
  const allNotes = useSelector(
    (state) =>
      state?.prescriptionReducer?.prescriptionInfo?.itemElementNotes || [],
  );
  console.log('all_notes', allNotes);

  const eyeExamination =
    selectedOnExamination?.eyeExamination || defaultEyeExamination();

  const handleChange = (key, side, value) => {
    const updated = {
      ...eyeExamination,
      [key]: { ...eyeExamination[key], [side]: value },
    };
    handleOnExaminationData(updated, 'eyeExamination');
  };

  const clearRow = (key) => {
    const updated = { ...eyeExamination, [key]: { right: '', left: '' } };
    handleOnExaminationData(updated, 'eyeExamination');
  };

  const getSpecificNotes = (name, leftOrRight) => {
    const notes = allNotes.filter(
      (note) =>
        note.itemElement?.toLowerCase() === name?.toLowerCase() &&
        note.leftOrRight === leftOrRight,
    );
    return notes;
  };

  return (
    <div className="eye-examination-wrap">
      <Row className="eye-exam-header-row">
        <Col className="text-center fw-bold" style={{ marginLeft: '10px' }}>
          Right Eye
        </Col>
        <Col className="text-center fw-bold eye-exam-center-col">
          Eye Examination
        </Col>
        <Col className="text-center fw-bold" style={{ marginRight: '10px' }}>
          Left Eye
        </Col>
      </Row>

      {EYE_EXAM_ITEMS.map(({ key, label, placeholder }) => {
        const leftNotes = [];
        const rightNotes = [];
        const notesForKey = allNotes.filter((n) => {
          const elementParts = n?.itemElement?.split('_');
          if (elementParts?.length > 0 && elementParts[0] === key) {
            if (elementParts?.length > 1 && elementParts[1] === 'left') {
              leftNotes.push(n);
            } else if (
              elementParts?.length > 1 &&
              elementParts[1] === 'right'
            ) {
              rightNotes.push(n);
            }
            return true;
          } else {
            return false;
          }
        });
        return (
          <Row key={key} className="eye-exam-data-row align-items-center">
            <Col style={{ marginLeft: '10px' }}>
              <NoteDropdown
                value={eyeExamination[key]?.right || ''}
                onChange={(val) => handleChange(key, 'right', val)}
                placeholder={placeholder}
                suggestions={rightNotes}
              />
            </Col>
            <Col className="eye-exam-center-col d-flex align-items-center justify-content-between px-3">
              <span>{label}</span>
              <button
                className="eye-exam-plus-btn"
                title="Clear row"
                onClick={() => clearRow(key)}
              >
                <i className="fas fa-plus" />
              </button>
            </Col>
            <Col style={{ marginRight: '10px' }}>
              <NoteDropdown
                value={eyeExamination[key]?.left || ''}
                onChange={(val) => handleChange(key, 'left', val)}
                placeholder={placeholder}
                suggestions={leftNotes}
              />
            </Col>
          </Row>
        );
      })}
    </div>
  );
};

export default memo(EyeExamination);
